import React, { useState } from "react";
import { Table, ChevronDownIcon, CaptionText, ChevronUpIcon, LoadingSpinner, ContextualAlert, Container, Row, Col } from "@paypalcorp/pp-react";
import ReactHtmlParser from "react-html-parser";
import { get } from "lodash";
import withTheme from "../../common/withTheme";

const PendingPayoutTable = (props) => {
  const [showTransactionData, setShowTransactionData] = useState([]);
  const handleRowExpansion = (rowId) => {
    const transactionRowId = showTransactionData.slice();
    if (transactionRowId.indexOf(rowId) >= 0) {
      transactionRowId.splice(transactionRowId.indexOf(rowId), 1);
      setShowTransactionData(transactionRowId);
    } else {
      transactionRowId.push(rowId);
      setShowTransactionData(transactionRowId);
    }
  };

  let renderPendingPayoutData = props.pendingPayoutData.map((result, index) => {
    let arr = [];
    arr.push(
      <tr key={`row-index${index}`} style={{ background: "#FAFAFA" }}>
        <td colSpan="5">
          <Container fluid={true} className="grid-demo">
            <Row className="demo-row">
              {get(result, "encrypted_sender_transaction_id") && (
                <Col>
                  <div>
                    <CaptionText>
                      {props.dashboardPageMsg.dashboard.transactionId}
                    </CaptionText>
                    <CaptionText style={{ color: "#515354", marginTop: "12px" }}>
                      {get(result, "encrypted_sender_transaction_id", "")}
                    </CaptionText>
                  </div>
                </Col>
              )}
              {get(result, "campaign_title") && (
                <Col>
                  <div>
                    <CaptionText>
                      {props.dashboardPageMsg.dashboard.campaigntitle}
                    </CaptionText>
                    <CaptionText style={{ color: "#515354", marginTop: "12px" }}>
                      {get(result, "campaign_title", "")}
                    </CaptionText>
                  </div>
                </Col>
              )}
              {get(result, "item_id") && (
                <Col>
                  <div>
                    <CaptionText>
                      {props.dashboardPageMsg.dashboard.ebayli}
                    </CaptionText>
                    <CaptionText style={{ color: "#515354", marginTop: "12px" }}>
                      {get(result, "item_id", "")}
                    </CaptionText>
                  </div>
                </Col>
              )}
              {get(result, "grossAmount") && (
                <Col>
                  <div>
                    <CaptionText style={{ textAlign: "right" }}>
                      {props.dashboardPageMsg.dashboard.grossAmount}
                    </CaptionText>
                    <CaptionText
                      style={{
                        color: "#515354",
                        textAlign: "right",
                        margin: "12px 0px 32px 0px",
                      }}
                    >
                      <span className={result.payout_symbol == "neg" ? "neg" : ""} />
                      {get(result, "grossAmount", "")}
                    </CaptionText>
                  </div>
                </Col>
              )}
              {get(result, "totalFees") && (
                <Col>
                  <div>
                    <CaptionText
                      style={{
                        color: "#515354",
                        textAlign: "right",
                      }}
                    >
                      {props.dashboardPageMsg.dashboard.totalfees}
                    </CaptionText>
                    <CaptionText
                      style={{
                        color: "#515354",
                        textAlign: "right",
                        margin: "9px 0px 32px 17px",
                      }}
                    >
                      {get(result, "totalFees", "")}
                    </CaptionText>
                  </div>
                </Col>
              )}
            </Row>
          </Container>
        </td>
        <td />
      </tr>
    );

    return (
      <React.Fragment>
        <tr key={index} className="pendingDonationData" onClick={() => handleRowExpansion(index)}>
          <td className="date">
            {result.donationDate}
          </td>
          <td>
            {result.donor_name}
            <CaptionText>{result.donor_email_address}</CaptionText>
          </td>
          <td>{result.partner_name}</td>
          <td>{result.payout_description}</td>
          <td style={{ textAlign: "right" }}>
            <span className={result.payout_symbol == "neg" ? "neg" : ""} />
            {result.payoutAmount}
          </td>
          <td style={{ textAlign: "right" }}>
            {showTransactionData.includes(index) ?
              <ChevronUpIcon size="xs" style={{ color: "#1040C1" }} />
              :
              <ChevronDownIcon size="xs" style={{ color: "#1040C1" }} />
            }
          </td>
        </tr>
        {showTransactionData.includes(index) && arr}
      </React.Fragment>
    );
  });

  return (
    <React.Fragment>
      <section id="pendingPayoutResult">
        <Table isFullWidth>
          <thead>
            <tr>
              <th>{props.dashboardPageMsg.dashboard.date}</th>
              <th>
                {ReactHtmlParser(props.dashboardPageMsg.dashboard.donorName)}
              </th>
              <th>{props.dashboardPageMsg.dashboard.partner}</th>
              <th>{props.dashboardPageMsg.dashboard.program}</th>
              <th style={{ textAlign: "right" }}>
                {props.dashboardPageMsg.dashboard.totalAmount}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {renderPendingPayoutData.length == 0 && props.pendingPayoutDataError &&
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  <ContextualAlert type="error">
                    {props.dashboardPageMsg.dashboard.tryLater}
                  </ContextualAlert>
                </td>
              </tr>
            }
            {props.pendingPayoutLoader &&
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  <div className="pendingDonationsLoader">
                    <LoadingSpinner size="md" screenReaderText={props.dashboardPageMsg.loading} />
                  </div>
                </td>
              </tr>
            }
            {renderPendingPayoutData.length == 0 && props.pendingPayoutNoRecordsMsg ?
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  <CaptionText style={{ margin: '10px' }}>
                    {props.dashboardPageMsg.dashboard.noPDRecords}
                  </CaptionText>
                </td>
              </tr>
              : renderPendingPayoutData
            }
          </tbody>
        </Table>
      </section>
    </React.Fragment>
  );
};
export default withTheme(PendingPayoutTable);
